import messages from './messages';

const Schema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.portknoxPlans),
    block: 'portknoxplans',
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.default),
        fields: ['title', 'description', 'mode', 'paypalClientId'],
      },
    ],

    properties: {
      title: {
        title: intl.formatMessage(messages.title),
      },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      mode: {
        title: intl.formatMessage(messages.mode),
        description: intl.formatMessage(messages.modeDescription),
        choices: [
          ['website', 'Website'],
          ['app', 'App'],
        ],
        default: 'website',
      },
      paypalClientId: {
        title: intl.formatMessage(messages.paypalClientId),
        description: intl.formatMessage(messages.paypalClientIdDescription),
      },
    },
    required: [],
  };
};

export default Schema;
